'use strict';


module.exports = function (client) {

    client.disco.addFeature('urn:xmpp:psa');
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/psa.js
// module id = 625
// module chunks = 2